export const products = ["wicked witch", "dire wolf", "alice", "cat butt", "dragon"];